import { getIsCheckoutLoaded } from 'redux/modules/checkout/selectors/get-is-checkout-loaded';
import type { FetcherArgs } from 'route-data/fetcher-types';

export const isCheckoutFetchRequired = (
  _args: FetcherArgs<string>,
  getState: () => WtrState,
): boolean => {
  return !getIsCheckoutLoaded(getState());
};
